<div class="pin-code-input-wrapper">
    <!-- autocomplete="new-password" helps prevent browser password manager saving first number of pin as site password -->
    <input v-for="(cell, index) in cells"
           :autocomplete="getRandomAutoCompleteValue()"
           required="required"
           :key="cell.key"
           :ref="`input${index}`"
           v-model.trim="cell.value"
           v-bind="$attrs"
           class="pin-code-input"
           :class="{ 'hide-char': cellsHideChar[index] }"
           :type="cellsInputTypes[index]"
           @focus="focusedCellIdx = index"
           @keydown.delete="onCellErase(index, $event)"
           @keydown="onKeyDown"
    >
</div>